import { FC, useCallback } from 'react';

import { IKdsApiDisplay } from '~/modules/board/interfaces/IKdsApiDisplay';
import { useKeyActions } from '~/modules/board/hooks/keyActions';

import { Container, DisplayOption } from './styles';

interface IDisplaySelectionModalProps {
  readonly displays: IKdsApiDisplay[];
  readonly current: string;
  readonly displaySelectionFocus: number;
  readonly onConfirm: (display: IKdsApiDisplay) => void;
}
export const DisplaySelectionModal: FC<IDisplaySelectionModalProps> = ({
  displays,
  current,
  onConfirm,
}) => {
  const { displaySelectionFocus } = useKeyActions();

  const renderDisplayOption = useCallback(
    (display: IKdsApiDisplay, index: number) => {
      const { _id, environments, name } = display;
      const environmentsNames = environments.map((env) => env.name);

      return (
        <DisplayOption
          id={`display-option-index-${index}`}
          onClick={() => onConfirm(display)}
          selected={_id === current || displaySelectionFocus === index}
        >
          <span>{name}</span>
          <small>{environmentsNames.join(', ')}</small>
        </DisplayOption>
      );
    },
    [current, onConfirm, displaySelectionFocus]
  );

  return (
    <Container>
      <div>
        {displays.map((display, index) => renderDisplayOption(display, index))}
      </div>
    </Container>
  );
};
